export default __webpack_public_path__ + "static/media/discounts-weather-image.a798fd7f.svg";